// /* product-skeleton.js – handles both card types */
// document.addEventListener('DOMContentLoaded', () => {

//   // any primary image inside the figure – covers both templates
//   const IMG_SELECTOR =
//     '.product-card__figure .product-card__image--primary,' +
//     '.product-card__figure .card-product__image--primary';

//   document.querySelectorAll(IMG_SELECTOR).forEach(img => {
//     const fig = img.closest('.product-card__figure');
//     if (!fig) return;

//     // ensure loader shows at least 200 ms, even from cache
//     const start     = performance.now();
//     const MIN_SHOW  = 2000;            // ms
//     const hide = () => {
//       const delay = Math.max(0, MIN_SHOW - (performance.now() - start));
//       setTimeout(() => fig.classList.add('loaded'), delay);
//     };

//     if (img.complete && img.naturalWidth) {
//       hide();                         // came from cache
//     } else {
//       img.addEventListener('load', hide, { once: true });
//       img.addEventListener('error', hide, { once: true });
//     }
//   });
// });


/* product-skeleton.js – v5 minimum-show version */
document.addEventListener('DOMContentLoaded', () => {

  const FIGURE_SELECTOR =
    '.product-card__figure, .card-product__figure';

  const processed = new WeakSet();
  const MIN_SHOW  = 2000;              // ms you want the tick to appear

  function handleFigure(figure){
    if (!figure || processed.has(figure)) return;
    processed.add(figure);

    const img = figure.querySelector('img');
    if (!img) return figure.classList.add('loaded');

    // start timer now
    const t0 = performance.now();

    function hide(){
      const elapsed = performance.now() - t0;
      const delay   = Math.max(0, MIN_SHOW - elapsed);
      setTimeout(()=>figure.classList.add('loaded'), delay);
    }

    if (img.complete && img.naturalWidth){
      hide();                         // came from cache
    }else{
      img.addEventListener('load',  hide, {once:true});
      img.addEventListener('error', hide, {once:true});
    }

    // fail-safe after 6 s
    setTimeout(hide, 6000);
  }

  /* 1️⃣ initial pass */
  document.querySelectorAll(FIGURE_SELECTOR).forEach(handleFigure);

  /* 2️⃣ watch for figures added later (e.g. Related products) */
  const mo = new MutationObserver(muts=>{
    muts.forEach(m=>{
      m.addedNodes.forEach(node=>{
        if (node.nodeType!==1) return;

        if (node.matches && node.matches(FIGURE_SELECTOR)){
          handleFigure(node);
        }
        node.querySelectorAll && node.querySelectorAll(FIGURE_SELECTOR)
            .forEach(handleFigure);
      });
    });
  });
  mo.observe(document.body,{childList:true,subtree:true});
});
